/* EdibleInkStore PDP behaviour.
   Everything is scoped to .eis-pdp so it cannot touch the rest of your theme.
   Loaded with `defer`, and also re-initialised on Shopify's theme-editor events
   so the sections keep working while you edit them in the customizer. */

(function () {
  'use strict';

  /* ---------- quantity steppers ---------- */
  function initQty(root) {
    root.querySelectorAll('.eis-pdp .qty').forEach(function (q) {
      if (q.dataset.eisReady) return;
      q.dataset.eisReady = '1';
      var input = q.querySelector('input');
      var btns = q.querySelectorAll('button');
      if (!input || btns.length < 2) return;
      btns[0].addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      btns[1].addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- media gallery ---------- */
  function initGallery(root) {
    root.querySelectorAll('.eis-pdp [data-eis-gallery]').forEach(function (gal) {
      if (gal.dataset.eisReady) return;
      gal.dataset.eisReady = '1';
      var main = gal.querySelector('[data-eis-main]');
      gal.querySelectorAll('.rail button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('.rail button').forEach(function (b) {
            b.setAttribute('aria-current', 'false');
          });
          btn.setAttribute('aria-current', 'true');
          var full = btn.getAttribute('data-full');
          var alt = btn.getAttribute('data-alt') || '';
          if (main && full) {
            main.setAttribute('src', full);
            main.setAttribute('alt', alt);
          }
        });
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants(root) {
    root.querySelectorAll('.eis-pdp [data-eis-variants]').forEach(function (box) {
      if (box.dataset.eisReady) return;
      box.dataset.eisReady = '1';
      var select = box.querySelector('[data-eis-variant-select]');
      var idInput = box.querySelector('[data-eis-variant-id]');
      var priceEl = box.querySelector('[data-eis-price]');
      var skuEl = box.querySelector('[data-eis-sku]');
      var addBtn = box.querySelector('[data-eis-add]');
      var addLabel = box.querySelector('[data-eis-add-label]');
      var dockPrice = document.querySelector('.eis-pdp [data-eis-dock-price]');
      if (!select) return;

      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (idInput) idInput.value = opt.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (skuEl && opt.dataset.sku) skuEl.textContent = opt.dataset.sku;
        if (dockPrice && opt.dataset.price) dockPrice.textContent = opt.dataset.price;
        if (addLabel && opt.dataset.price) {
          addLabel.textContent = addLabel.dataset.prefix + ' ' + opt.dataset.price;
        }
        var avail = opt.dataset.available === 'true';
        if (addBtn) {
          addBtn.disabled = !avail;
          if (!avail && addLabel) addLabel.textContent = addLabel.dataset.soldout || 'Sold out';
        }
      });
    });
  }

  /* ---------- smooth scroll for the on-page table of contents ---------- */
  function initToc(root) {
    root.querySelectorAll('.eis-pdp .toc a, .eis-pdp .jump').forEach(function (a) {
      if (a.dataset.eisReady) return;
      a.dataset.eisReady = '1';
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 80,
          behavior: 'smooth'
        });
      });
    });
  }

  /* ---------- photo-on-cake preview ---------- */
  function initPreview(root) {
    root.querySelectorAll('.eis-pdp [data-eis-preview]').forEach(function (tool) {
      if (tool.dataset.eisReady) return;
      tool.dataset.eisReady = '1';

      var board = tool.querySelector('[data-eis-board]');
      var file = tool.querySelector('input[type="file"]');
      var drop = tool.querySelector('.drop');
      var mode = 'round';
      var src = null;
      if (!board) return;

      function pipe(n) {
        var o = '<svg class="pipe" viewBox="0 0 100 100" aria-hidden="true">';
        for (var i = 0; i < n; i++) {
          var a = (i / n) * Math.PI * 2;
          o += '<circle cx="' + (50 + 45.5 * Math.cos(a)).toFixed(2) +
               '" cy="' + (50 + 45.5 * Math.sin(a)).toFixed(2) +
               '" r="3.4" fill="#fff" stroke="rgba(27,23,21,.07)" stroke-width=".5"/>';
        }
        return o + '</svg>';
      }
      function crop() {
        var inner = src
          ? '<img src="' + src + '" alt="Your photo previewed on a cake">'
          : '<span class="ph">' + (tool.dataset.placeholder || 'Your photo<br>appears here') + '</span>';
        return '<div class="crop">' + inner + '</div>';
      }
      function render() {
        if (mode === 'round') {
          board.innerHTML = '<div class="cake-round">' + pipe(26) + crop() + '</div>';
        } else if (mode === 'cup') {
          var g = '';
          for (var i = 0; i < 12; i++) g += '<div class="cup">' + crop() + '</div>';
          board.innerHTML = '<div class="cupgrid">' + g + '</div>';
        } else {
          board.innerHTML = '<div class="cake-rect">' + pipe(30) + crop() + '</div>';
        }
      }
      function load(f) {
        if (!f || !/^image\//.test(f.type)) return;
        if (f.size > 12 * 1024 * 1024) { alert('That image is very large. Please use one under 12 MB.'); return; }
        var r = new FileReader();
        r.onload = function (e) { src = e.target.result; render(); };
        r.readAsDataURL(f);
      }

      if (file) file.addEventListener('change', function (e) { load(e.target.files[0]); });
      if (drop) {
        ['dragenter', 'dragover'].forEach(function (t) {
          drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('hot'); });
        });
        ['dragleave', 'drop'].forEach(function (t) {
          drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('hot'); });
        });
        drop.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files) load(e.dataTransfer.files[0]);
        });
      }
      tool.querySelectorAll('.mode').forEach(function (b) {
        b.addEventListener('click', function () {
          tool.querySelectorAll('.mode').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          mode = b.dataset.mode || 'round';
          render();
        });
      });
      render();
    });
  }

  function initAll(root) {
    root = root || document;
    initQty(root);
    initGallery(root);
    initVariants(root);
    initToc(root);
    initPreview(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify theme editor: re-run when a section is added or redrawn */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();